export default "__VITE_ASSET__BOGAfzza__"